import {
  FETCH_ORG_DATA_START,
  FETCH_ORG_DATA_FULFILLED,
  FETCH_ORG_DATA_REJECTED,
} from './actionTypes';

const initialState = {
  orgData: null,
};

const joinDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORG_DATA_START:
      return {
        ...state,
      };

    case FETCH_ORG_DATA_FULFILLED:
      return {
        ...state,
        orgData: action.payload,
      };

    case FETCH_ORG_DATA_REJECTED:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default joinDataReducer;
